import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar'; 
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Link, useNavigate } from 'react-router-dom';
import './components/css/Navbar.css';
import axios from 'axiosInstance';
import { getUserRole } from './components/authLogin/Rol';
import logo from './assets/logoColonias.png';

import 'bootstrap/dist/css/bootstrap.min.css';

const Navigation = () => {
  const navigate = useNavigate();
  const role = getUserRole();  

  const handleLogout = async () => {
    try {
      const token = sessionStorage.getItem('token');

      if (token) {
        await axios.post(
          process.env.REACT_APP_BACKEND_URL + '/api/auth/logout'
        );
      }

      sessionStorage.removeItem('token');
      sessionStorage.removeItem('user');
      navigate('/login');
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  };

  return (
    <Navbar expand="lg" className="navegador">
      <Container className="container-md">
        <Navbar.Brand as={Link} to="/" className='links'>
              <img
              alt=""
              src={logo}
              width="50"
              height="50"
              className="d-inline-block align-top me-2"
            />
            INTRANET</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">

            {role === 'normal' && (
              <>
                <Nav.Link as={Link} to="/EventoUser" className='links me-3'>Eventos</Nav.Link>
                <Nav.Link as={Link} to="/InscripcionUser" className='links me-3'> Mis Inscripciones </Nav.Link>
              <Nav.Link as={Link} to="CalendarioEventos" className='links me-3'>Calendario</Nav.Link>
              <Nav.Link as={Link} to="/Contacto" className='links me-3'>Contacto</Nav.Link>


              </>
            )}

            {role === 'admin' && (
              <>
                <Nav.Link as={Link} to="/Eventos" className='links me-3'>Eventos</Nav.Link>
                <Nav.Link as={Link} to="/Inscripciones" className='links me-3'>Inscripciones</Nav.Link>
              <Nav.Link as={Link} to="CalendarioEventos" className='links me-3'>Calendario</Nav.Link>
              <Nav.Link as={Link} to="/Contacto" className='links me-3'>Contacto</Nav.Link>

              </>
            )}
            
             {!sessionStorage.getItem('token') && (
                <>
                  <Nav.Link as={Link} to="/login" className='links me-3'>Login / Registro</Nav.Link>
                </>
              )}
        
              {sessionStorage.getItem('token') && (
                <>
                  <Nav.Link onClick={handleLogout} className='links me-3'>Logout</Nav.Link>
                </>
              )}

          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;

